const config = {
  apiKey: "AIzaSyBPBM6oAnwrYxLtwbs3jHbopV5HrGtkCH0",
  authDomain: "crwn-clothing-6452c.firebaseapp.com",
  databaseURL: "https://crwn-clothing-6452c.firebaseio.com",
  projectId: "crwn-clothing-6452c",
  storageBucket: "crwn-clothing-6452c.appspot.com",
  messagingSenderId: "591637881998",
  appId: "1:591637881998:web:7ebbba574174c3dfe455df"
};

export default config;
